import React from 'react';
import styled from 'styled-components';

interface DownloadModalProps {
    isOpen: boolean;
    onClose: () => void;
    onTryApp: () => void;
    onDownloadOnly: () => void;
}

export const DownloadModal: React.FC<DownloadModalProps> = ({
    isOpen,
    onClose,
    onTryApp,
    onDownloadOnly
}) => {
    if (!isOpen) return null;

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <ModalHeader>
                    <h2>Before You Download for FREE...</h2>
                </ModalHeader>
                <ModalBody>
                    <p>Are you looking to sell digital products on Shopify for FREE?</p>
                </ModalBody>
                <ModalFooter>
                    <PrimaryButton onClick={onTryApp}>
                        Try BIG Digital Download AND Download
                    </PrimaryButton>
                    <SecondaryButton onClick={onDownloadOnly}>
                        No, Just Download
                    </SecondaryButton>
                </ModalFooter>
            </ModalContent>
        </ModalOverlay>
    );
};

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.div`
    margin-bottom: 20px;
    text-align: center;

    h2 {
        font-size: 24px;
        color: #333;
        margin: 0;
    }
`;

const ModalBody = styled.div`
    margin-bottom: 24px;
    text-align: center;

    p {
        font-size: 16px;
        color: #666;
        line-height: 1.5;
    }
`;

const ModalFooter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const Button = styled.button`
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
`;

const PrimaryButton = styled(Button)`
    background: #ff6320;
    color: white;
    border: none;

    &:hover {
        background: #e55a1d;
    }
`;

const SecondaryButton = styled(Button)`
    background: white;
    color: #666;
    border: 1px solid #ddd;

    &:hover {
        background: #f5f5f5;
    }
`; 